import { StockMovement } from '../../../models/StockMovement';

/** Normaliza status para comparação (pt-BR / API). */
export function normalizeMovementStatusKey(value: string | undefined | null): string {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '');
}

export function isStockEntryMovementRow(m: StockMovement): boolean {
  const t = String(m.movementType || '').toLowerCase();
  return t === 'entry' || t === 'entrada';
}

/**
 * Status em que a linha ainda não tem `itemId` de estoque e precisa do
 * `PUT .../pending-item-requests/{id}/link-item` (ex.: solicitado,
 * aguardando cadastro, etc.).
 */
export function rowStatusSuggestsPendingItemLink(m: StockMovement): boolean {
  const st = normalizeMovementStatusKey(m.status);
  if (!st) return false;
  if (st.includes('transito') || st.includes('intransit')) return false;
  if (st.includes('receb') && !st.includes('solicit')) return false;
  if (st.includes('conclu') || st.includes('execut') || st.includes('cancel')) return false;

  if (
    st.includes('aguardandocad') ||
    st.includes('awaitingcad') ||
    st.includes('awaitingreg') ||
    (st.includes('aguardando') && (st.includes('cad') || st.includes('cadastro')))
  ) {
    return true;
  }

  return (
    st.includes('solicit') ||
    st === 'requested' ||
    st.includes('pendenteitem') ||
    st.includes('aguardandovinculo') ||
    st.includes('semitem')
  );
}

/**
 * Id usado em `.../pending-item-requests/{id}/link-item`.
 * Preferência: `pendingItemEntryId` da API; fallback: `movement.id` quando
 * entrada sem item e status indica pendência de vínculo.
 */
export function resolvePendingItemEntryIdForLink(m: StockMovement): number | null {
  const explicit = m.pendingItemEntryId;
  if (explicit != null && explicit > 0) {
    return explicit;
  }
  if (!isStockEntryMovementRow(m)) return null;
  const noStockItem = m.itemId == null || m.itemId <= 0;
  if (!noStockItem) return null;
  if (!rowStatusSuggestsPendingItemLink(m)) return null;
  return m.id > 0 ? m.id : null;
}

/** Entrada em lista ou detalhe que ainda aceita vínculo com item cadastrado. */
export function canLinkPendingItemToStockEntry(m: StockMovement): boolean {
  return resolvePendingItemEntryIdForLink(m) != null;
}
